import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { NagMessage } from '@uigy/shared/components/nag/models/nag-message';
import { NagService } from '@uigy/shared/components/nag/services/nag.service';
import {
  UIButtonIconComponent
} from '@uigy/shared/components/ui-button/button-icon/ui-button-icon.component';
import {
  UIButtonTextComponent
} from '@uigy/shared/components/ui-button/button-text/ui-button-text.component';
import { UIButtonComponent } from '@uigy/shared/components/ui-button/ui-button.component';
import { isObservable, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { NavigationExtras, Router } from '@angular/router';
import { TabGroup } from '@uigy/shared/components/tabs/tabs.enums';

export interface NagMessageWithLoading extends NagMessage {
  loading?: boolean;
}

@Component({
  selector: 'app-nag',
  templateUrl: './nag.component.html',
  styleUrls: ['./nag.component.scss'],
  imports: [
    UIButtonComponent,
    AsyncPipe,
    UIButtonTextComponent,
    UIButtonIconComponent
],
})
export class NagComponent implements OnInit {
  private nagService = inject(NagService);
  private router = inject(Router);

  protected readonly IconsEnum = IconsEnum;
  public messages$?: Observable<NagMessageWithLoading[]>;

  public ngOnInit(): void {
    this.messages$ = this.nagService.messages$;
  }

  public remove(msg: NagMessageWithLoading): void {
    this.nagService.removeMessage(msg.type);
  }

  public action(msg: NagMessageWithLoading): void {
    msg.loading = true;
    if (!msg.action) {
      return;
    }
    const actionRes = msg.action();
    if (isObservable(actionRes)) {
      actionRes
        .pipe(
          take(1),
          finalize(() => (msg.loading = false)),
        )
        .subscribe(() => this.remove(msg));
    } else {
      msg.loading = false;
    }
  }

  public navigate(msg: NagMessage): void {
    if (msg.route) {
      let params: NavigationExtras = {};
      if (msg.tab) {
        params = { queryParams: { [TabGroup.DataSources]: msg.tab } };
      }
      this.router.navigate(msg.route, params);
    }
  }
}
